export default "__VITE_ASSET__BvgeKmwX__"